import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import baseURL from "../../authComponents/baseURL/BaseURL";
import support from "../../../assets/images/support.jpg";
const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    subject: "",
    email: "",
    issues: "",
    message: "",
  });
  const [showPopup, setShowPopup] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError("");

    try {
      // Correct API call using baseURL
      await baseURL.post("/contact_us", formData);

      // Show success popup
      setShowPopup(true);

      // Reset form
      setFormData({ subject: "", email: "", issues: "", message: "" });

      // Redirect after 3 seconds
      setTimeout(() => {
        setShowPopup(false);
        navigate("/");
      }, 3000);
    } catch (err) {
      setError("Failed to submit form. Please try again later.");
      console.error("Form submission error:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex items-center font-serif justify-center py-12 bg-gray-100 min-h-screen relative">
      {/* Success Popup */}
      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                <svg
                  className="h-6 w-6 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
              </div>
              <h3 className="mt-4 font-serif text-lg font-medium text-gray-900">
                Submission Successful!
              </h3>
              <p className="mt-2 text-sm text-gray-500">
                Thank you for contacting us. We will get back to you shortly.
              </p>
              {/* <div className="mt-4">
                <p className="text-sm text-gray-500">
                  Redirecting to homepage...
                </p>
              </div> */}
            </div>
          </div>
        </div>
      )}

      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Contact Form */}
          <div className="bg-white p-8 rounded-lg shadow-md">
            <form onSubmit={handleSubmit} className="space-y-6">
              <h2 className="text-4xl font-bold text-[#730000] mb-4">
                Write to Us
              </h2>
              <p className="text-gray-600 mb-6">
                Have a question, suggestion, or need assistance? Fill out the
                form below, and one of our experts will be in touch with you
                shortly.
              </p>

              {error && (
                <div className="p-3 bg-red-100 text-red-700 rounded-md mb-4">
                  {error}
                </div>
              )}

              <div>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#730000]"
                  placeholder="Subject *"
                />
              </div>
              <div>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#730000]"
                  placeholder="Your Message"
                  rows="5"
                ></textarea>
              </div>
              <div>
                <input
                  type="tel"
                  name="issues"
                  value={formData.issues}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#730000]"
                  placeholder="Type your issues *"
                />
              </div>
              <div>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#730000]"
                  placeholder="Your Email *"
                />
              </div>
              <div className="text-right">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`px-6 py-3 bg-[#730000] text-white rounded-md transition duration-300 ${
                    isSubmitting
                      ? "opacity-70 cursor-not-allowed"
                      : "hover:bg-red-700"
                  }`}
                >
                  {isSubmitting ? "Sending..." : "Send Message"}
                </button>
              </div>
            </form>
          </div>

          {/* Support Information */}
          <div className="bg-white p-8 rounded-lg shadow-md">
            <h2 className="text-4xl font-bold text-[#730000] mb-6">Support</h2>

            <div className="mb-6">
              <h3 className="text-2xl font-semibold text-[#730000] mb-4">
                Why SelectProposal.com?
              </h3>
              <p className="text-gray-600">
                Many matrimonial websites fail to provide genuine and authentic
                proposals, often filled with fake profiles or misleading
                information.
              </p>
              <p className="text-gray-600 mt-4">
                Through extensive research, our team discovered that numerous
                platforms allow unverified users, including teenagers and
                non-serious individuals, leading to a loss of credibility.
              </p>
              <p className="text-gray-600 mt-4">
                At SelectProposal.com, we ensure 100% authenticity by
                implementing a strict verification process for every registered
                proposal, leaving no room for fake profiles.
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-semibold text-[#730000] mb-4">
                Why a Non-Refundable Registration Fee?
              </h3>
              <p className="text-gray-600">
                To uphold the authenticity and quality of our service, Select
                Proposal charges a non-refundable registration fee through HBL,
                UBL, EasyPaisa, UPaise, and UBL Omni. This fee serves two
                crucial purposes:
              </p>

              <div className="flex flex-col md:flex-row mt-4">
                <div className="md:w-2/3 pr-4">
                  <ol className="list-decimal pl-6 text-gray-600">
                    <li className="mb-2">
                      <strong>Filtering Out Non-Serious Users</strong> – Genuine
                      individuals seeking a meaningful relationship find it
                      reasonable to pay for quality matchmaking, while fake or
                      non-serious users are discouraged from registering.
                    </li>
                    <li>
                      <strong>Ensuring Dedicated Support</strong> – The fee
                      allows us to provide 24/7 telephonic, email, and SMS
                      support, ensuring a seamless and professional experience
                      for our members.
                    </li>
                  </ol>
                </div>
                <div className="md:w-1/3 mt-4 md:mt-0">
                  <img
                    src={support}
                    alt="Support"
                    className="rounded-md w-full"
                  />
                </div>
              </div>
            </div>

            <div className="mt-6">
              <p className="text-gray-600">
                Our platform is designed and managed by industry professionals,
                making the registration process simple and user-friendly. Anyone
                with basic internet knowledge can easily sign up and begin their
                journey toward a meaningful, educated, and lasting relationship.
              </p>
            </div>

            <Link to="/termAndConditions" className="block mt-4">
              <p className="text-blue-600 hover:text-blue-800">
                Learn more about our T&Cs
              </p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
